import { NavLink, Outlet, useLocation } from 'react-router-dom'

export default function SponsorAiLayout() {
  const location = useLocation()
  const path = location.pathname
  const toolsActive = path === '/sponsor/ai' || path === '/sponsor/ai/tools'

  return (
    <div className="mx-auto max-w-5xl px-4 py-8">
      <nav className="mb-6 flex gap-3 text-sm">
        <NavLink
          to="/sponsor/ai/tools"
          className={({ isActive }) =>
            `rounded-full px-3 py-1 ${
              toolsActive || isActive ? 'bg-stone-900 text-white' : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
            }`
          }
        >
          AI Tools
        </NavLink>
        <NavLink
          to="/sponsor/ai/marketplace"
          className={({ isActive }) =>
            `rounded-full px-3 py-1 ${
              isActive ? 'bg-stone-900 text-white' : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
            }`
          }
        >
          Marketplace
        </NavLink>
      </nav>

      <Outlet />
    </div>
  )
}
